
import { computed, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

export default {
    setup() {
        const store = useStore();
        const calendar = store.state.calendar;
        const router = useRoute();
        const messageId = router.params.messageId;
        const loadingApply = ref(false);

        onMounted(() => {
            store.dispatch('calendar/GET_SYNC_MEMBER_MESSAGES', { messageId });
        });

        const loading = computed(() => calendar.loadingSycnMemeber);
        const messageInfo = computed(() => calendar.sycnMemeberInfo);
        const syncState = computed(() => calendar.syncState);

        const click = (type: number) => {
            const action = type === 1 ? 'calendar/SCHEDULE_INVITATION_AGREED' : 'calendar/SCHEDULE_INVITATION_REFUSED';
            loadingApply.value = true;
            store.dispatch(action, { messageId }).finally(() => {
                loadingApply.value = false;
            });
        };

        return {
            loading,
            loadingApply,
            messageInfo,
            click,
            syncState,
        };
    },
};
